module.exports = __webpack_public_path__ + "static/media/22.60e6ae95.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/22.png
// module id = 525
// module chunks = 0